module.exports = __webpack_public_path__ + "static/11.2_ancient_greece-8b7dbdcddee7fc0c1c07f18a52c1325b.pdf";